import router from '@/router'
import cmd from '@/common/Command'

const MenuModule = {
  namespaced: true,
  state: {
  },
  mutations: {},
  actions: {
    showWord ({ commit, state, rootState }) {
      // 用語解説一覧
      rootState.currentMenu = 'word'
      router.push(rootState.currentMenu)

      //初期化
      this.dispatch("initWord")
    },
    showQuestion ({ commit, state, rootState }) {
      // 一問一答一覧
      rootState.currentMenu = 'question'
      router.push(rootState.currentMenu)

      //初期化
      this.dispatch("initQuestion")
    },
    showMovie ({ commit, state, rootState }) {
      // 動画
      rootState.currentMenu = 'movie'
      router.push(rootState.currentMenu)
    },
    showWebGis ({ commit, state, rootState }) {
      // WebGIS
      rootState.currentMenu = 'gis'
      router.push(rootState.currentMenu)
    },
    showStat ({ commit, state, rootState }) {
      // 統計資料
      window.open("https://ict.teikokushoin.co.jp/statistics_31jh/japan.xhtml", '_blank');
      /*
      function callback(rows){
        $.each(rows, function(idx, row){
          var url = row[0]
          window.open(url, '_blank');
          return false        
        })
      }
      cmd.getData("stat", callback)
      */
    },
    showRule ({ commit, state, rootState }) {
      // 利用規約
      var url = ""
      if (process.env.SUBJECT == "geo") {
        url = "static/data/" + process.env.SUBJECT + "/terms_geo1.png"
      }
      else if (process.env.SUBJECT == "history") {
        url = "static/data/" + process.env.SUBJECT + "/terms_his1.png"
      }
      else {
        url = "static/data/" + process.env.SUBJECT + "/terms_pub.png"
      }
      window.open(url, '_blank');
    },

    showMap ({ commit, state, rootState }) {
      // 地図
      rootState.currentMenu = 'map'
      router.push(rootState.currentMenu)
    },
    showTimeline ({ commit, state, rootState }) {
      // 年表
      rootState.currentMenu = 'timeline'
      router.push(rootState.currentMenu)
    },
    showLaw ({ commit, state, rootState }) {
      // 法令集
      rootState.currentMenu = 'law'
      router.push(rootState.currentMenu)
    },
    showImage ({ commit, state, rootState }) {
      // 動く図版
      var url = "static/data/" + process.env.SUBJECT + "/mov_illust01.gif"
      window.open(url, '_blank');
      //rootState.currentMenu = 'image'
      //router.push(rootState.currentMenu)

    },
    showLink ({ commit, state, rootState }) {
      // 外部団体へのリンク
      rootState.currentMenu = 'link'
      router.push(rootState.currentMenu)
    },
    showSample ({ commit, state, rootState }) {
      // 判例
      rootState.currentMenu = 'sample'
      router.push(rootState.currentMenu)
    },

  },
  getters: {
    isGeo (state, getters, rootState) {
      if (process.env.SUBJECT == "geo") {
        return true
      } else {
        return false
      }
    },
    isHistory (state, getters, rootState) {
      if (process.env.SUBJECT == "history") {
        return true
      } else {
        return false
      }
    },
    isCivics (state, getters, rootState) {
      if (process.env.SUBJECT == "civics") {
        return true
      } else {
        return false
      }
    }

  }
}

export default MenuModule



// WEBPACK FOOTER //
// ./src/store/modules/MenuModule.js